<template>
	<div>
		<el-row class="transfer">
			<page-title :tit="msg"></page-title>
			<el-row class="mk">
				<div class="mk_tit">
					<h3>码标信息</h3>
				</div>
				<ul>
					<li v-for="(item,index) in presentdata" :key="index">

						<p><span class="tit">{{item.title}} :</span>{{item.context}}</p>
					</li>
				</ul>
			</el-row>
			
			<div class="download-apply">
				<a href="/UploadFiles/码标转让申请表.doc"><i class="el-icon-download"></i>下载码标转让申请表</a>
				<span>填写好过户申请表并盖公章/签字再扫描提交上传</span>
			</div>

			<div class="search-box">
				<!--请输入过户用户身份证号-->
				<el-input v-model="condition" :placeholder="placeholderTit">
					<el-select v-model="select" slot="prepend" placeholder="请选择" style="width: 120px;color: #1B59A8 !important; ">
						<el-option label="个人用户" value="5"></el-option>
						<el-option label="单位组织" value="4"></el-option>
					</el-select>
					<el-button slot="append" icon="el-icon-search" @click="search">搜索</el-button>
				</el-input>
			</div>
			<transition name="el-fade-in-linear">
				<div v-show="mkshow">
					<el-row class="mk">
						<div class="mk_tit">
							<h3>过户目标用户</h3>
						</div>
						<ul>
							<li v-for="(item,index) in target" :key="index">
								<!--<p v-for="(value,key) in item" :key="value.id"><span>{{value.title}} :</span>{{value.context}}</p>-->
								<p><span class="tit">{{item.title}} :</span>{{item.context}}</p>
							</li>
						</ul>
					</el-row>
					<div class="transferApply-form">
						<span><i>*</i>过户申请表：</span>
						<el-upload
						  class="upload-demo"
						  action="/api/upload/uploadImage"
						  :on-remove="handleApplyRemove"
						  :on-success="handleApplySuccess"
						  >
						  <el-button size="small" type="primary">点击上传</el-button>
						  <div slot="tip" class="el-upload__tip">文件格式为：JPG、PNG、PDF</div>
						</el-upload>
					</div>
					<el-row class="mk mk_btn" style="border:none;">
						<el-checkbox v-model="checked" style="display:inline-block;"></el-checkbox>
						<!--<div @click="ible=!ible">-->
						<!--2222222222-->
						<span style="font-size: 14px;cursor: pointer;" @click="ible=!ible">我已阅读并同意码标服务协议</span>
						<!--</div>-->

						<div>
							<el-button type="primary" style="margin-top:20px;" @click="makeover">确认过户</el-button>
						</div>
					</el-row>
				</div>
			</transition>
		</el-row>

		<el-dialog title="提示" :visible.sync="ible" width="40%" custom-class="dialog-box">
			<codedialog></codedialog>
			<span slot="footer" class="dialog-footer">
				<el-button @click="ible = false">取 消</el-button>
				<el-button type="primary" @click="ible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import codedialog from '@/components/CodeDialog'

	import PageTitle from '../components/PageTitle'
	export default {

		data() {
			return {
				mkshow: false,
				ible: false,
				//				河北广联信息技术有限公司
				condition: '',
				msg: "码标过户",
				select: '4',
				presentdata: [{
						title: '码标',
						context: ''
					},
					{
						title: '注册时间',
						context: ''
					},
					{
						title: '注册有效期',
						context: ''
					},
					//					{
					//						title: '解析IDcode',
					//						context: ''
					//					}
				],
				identification_ID: '',
				target: [],
				transferUnitID: '',
				checked: true,
				transferFile: ''	// 过户申请表
			}
		},
		components: {
			PageTitle,
			codedialog
		},
		created() {
			this.present();
		},
		props: {
			id: Number,

		},
		computed: {
			placeholderTit() {
				return parseInt(this.select) === 4 ? '请输入过户目标企业名称或企业IDcode' : '请输入过户用户身份证号'
			}

		},
		//		placeholderTit
		methods: {
			search() {

				//				console.log(this.target)
				this.$http.get(this.$api + '/organUnit/getUnitInfoByNameOrIDcode', {
					params: {
						unitNameOrIDcode: this.condition,
						platformRole: this.select

					}
				}).then(res => {
					console.log(res.body)
					if (res.body.result != 1) {
						//						message
						this.$message.error(res.body.message);
					} else {
						//						console.log(this.target) 
						let entity = res.body.entity;
						var fax = entity.fax
						if (this.select == 4) {
							this.target = [{
									title: '企业名称',
									context: entity.organunitname
								},
								{
									title: '企业IDcode',
									context: entity.organunit_oid
								},
								{
									title: '企业地址',
									context: entity.organunitaddress
								},
								{
									title: '联系人',
									context: entity.linkman
								},
								{
									title: '联系电话',
									context: fax.substr(0, 3) + '****' + fax.substr(fax.length - 4)
								},

							]
						} else {
							this.target = [{
									title: '姓名',
									context: entity.organunitname
								},
								//								{
								//									title: '单位IDcode',
								//									context: entity.organunit_oid
								//								},
								//								{
								//									title: '注册地址',
								//									context: entity.organunitaddress
								//								},
								//								{
								//									title: '联系人',
								//									context: entity.linkman
								//								},
								{
									title: '联系电话',
									context: fax.substr(0, 3) + '****' + fax.substr(fax.length - 4)
								},
								{
									title: '身份证号',
									context: entity.organizationcode
								},

							]
						}

						//							this.target[0].context = entity.organunitname;
						//						this.target[1].context = entity.organunit_oid;
						//						this.target[2].context = entity.organunitaddress;
						//						this.target[3].context = entity.linkman;
						//						this.target[4].context = entity.fax;
						this.transferUnitID = entity.organunit_id_str
						//                    this.target[5].context=entity.linkman;
						this.mkshow = true;
					}
				}, rej => {
					this.$message.error('数据连接失败，请尝试重新操作');

				})
			},
			present() {
				this.$http.get(this.$api + '/identificationApply/getIdentificationInfoByID', {
					params: {
						identificationID: this.id
					}
				}).then(res => {
					if (res.body.result === 1) {
						let {
							identificationInfo
						} = res.body.entity;
						this.presentdata[0].context = identificationInfo.identification;
						this.presentdata[1].context = identificationInfo.createDate;
						this.presentdata[2].context = identificationInfo.regEffectiveTime;
						//						this.presentdata[3].context = identificationInfo.analyIDcode;
						this.identification_ID = identificationInfo.identification_ID
						//                    this.presentdata[4].context=identificationInfo.identification;

					}
				}, rej => {
					this.$message.error('数据连接失败，请尝试重新操作');

				})
			},
			handleApplySuccess(res, file) {	// 上传过户申请表
				var arr = []
				arr.push(res.entity.imageBig,res.entity.imageSmall)
				this.transferFile = arr.join('|')
			},
			handleApplyRemove(file) {
				this.transferFile = ''
			},
			makeover() {
				if (this.checked != false) {
					// this.$http.post(this.$api + '/identificationApply/saveIdentificationTransfer', {
					this.$http.post(this.$api + '/identificationApply/saveIdentificationTransferUnit', {
						identification_ID: this.identification_ID,
						transferUnitID: this.transferUnitID,
						transferFile: this.transferFile
					}).then(res => {
						//						console.log(res.body);
						if (res.body.result === 1) {

							this.$message({
								message: '过户成功，即将返回上一页',
								type: 'success'
							});
							this.$router.go(-1)
						} else {
							this.$message.error(res.body.message);
						}
					})
				} else {
					this.$message.error('请先勾选《我已阅读并同意码标服务协议》');

				}

			}
		},
		watch: {
			condition: function() {
				this.mkshow = false;

			}
		}

	}
</script>

<style lang="scss">
	.mk {
		font-size: 14px;
		/*padding: 0 0 100px 0;*/
		width: 592px;
		margin: 0 auto;
		margin-top: 22px;
		/*margin: 22px 0 0 227px;*/
		border: 1px solid #ebebeb;
		border-bottom: none;

		li {
			border-bottom: 1px solid #ecf2f4;
			width: 100%;
			padding: 19px 0;

			p {
				width: 100%;

				/*// line-height: 58px;*/
				span {
					display: inline-block;
					text-align: right;
				}
			}
		}

		.mk_tit {
			width: 100%;
			height: 40px;
			background-color: #f5f7fa;
			border-bottom: 1px solid #ecf2f4;

			h3 {
				line-height: 40px;
				color: #666666;
				font-size: 15px;
				margin-left: 30px;
			}

			.tit {
				font-size: 14px;
				display: inline-block;
				color: #333;
			}
		}
	}

	.mk_btn {
		text-align: center;
		margin-top: 35px;
	}

	.el-checkbox__label {
		font-size: 12px;
	}

	.search-box {
		/*width: 30%;*/
		width: 592px;
		margin: 0 auto;
		/*border: solid red 1px;*/
	}
	.download-apply {
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin: 20px 0 0;
		a {
			color: blue;
			font-size: 14px;
			line-height: 2;
			i {
				margin-right: 5px;
			}
		}
		span {
			font-size: 12px;
			color: #999;
		}
	}
	.transferApply-form {
		margin: 20px 0 0;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		>span {
			font-size: 14px;
			color: #666;
			i {
				color: red;
			}
		}
		.upload-demo {
			display: inline-flex;
			flex-direction: row;
			align-items: center;
			>div {
				margin: 0 5px;
			}
		}
	}
</style>
